module.exports = new __parcel__URL__("capsicum.30f76734.svg").toString();